<template>
  <slot name="douglas"/>
  <slot name="mark"/>
  <slot name="victor"/>
  <slot name="anousheh"/> 
  <slot name="launch"/> 
  <slot name="spaceport"/> 
  <slot name="spacecapsule"/> 
  <slot name="moon"/> 
  <slot name="mars"/> 
  <slot name="europa"/> 
  <slot name="titan"/> 
</template>

<script>
export default {

}
</script>
<style>

</style>